<div *ngIf="!show" class="arrow d-flex align-items-center justify-content-center">
  <i class="ti ti-chevron-right"></i>
</div>

<div *ngIf="show" class="justify-content-end">
  <app-button [outlined]="true" [size]="'sm'" [icon]="this.props?.icon" [label]="this.props?.label"
    (onClick)="this.props?.onClick(data)"></app-button>
</div>